// extracted by mini-css-extract-plugin
export default {"payroll-sum-emp-header":"PayrollSummEmpReport_payroll-sum-emp-header__XeNig","divider":"PayrollSummEmpReport_divider__g5W5X"};